import React, { useEffect, useState } from 'react';
import Papa from 'papaparse';
import { Accordion, AccordionHeader, AccordionBody, Link, Typography, } from '@one-thd/sui-atomic-components';
import { setBulkAddEventAnalytics } from '../../../../../utils/add-manage-user-analytics';
export var StepOne = function () {
    var _a = React.useState(false), expanded = _a[0], setExpanded = _a[1];
    var _b = useState(), templateDownloadLink = _b[0], setTemplateDownloadLink = _b[1];
    var handleChange = function (event, isExpanded) {
        setExpanded(isExpanded);
    };
    useEffect(function () {
        createCSVTemplate();
    }, []);
    var createCSVTemplate = function () {
        var fields = ['First Name', 'Last Name', 'Email', 'Role'];
        var data = new Array(4).fill('');
        var csv = Papa.unparse({
            data: data,
            fields: fields,
        });
        var blob = new Blob([csv], { type: 'text/csv' });
        setTemplateDownloadLink(URL.createObjectURL(blob));
    };
    return (React.createElement("div", { "data-testid": "upload-instructions-step1" },
        React.createElement("div", { className: "sui-flex sui-mb-2" },
            React.createElement("div", { className: "sui-min-w-[60px] sui-text-lg" },
                React.createElement(Typography, { weight: "bold" }, "Step 1:")),
            React.createElement(Typography, null,
                React.createElement(Link, { "data-testid": "download-link", download: "template.csv", href: templateDownloadLink, onClick: function () {
                        setBulkAddEventAnalytics('download template');
                    } }, "Download the CSV template"),
                ' ',
                "or create your own CSV file using another spreadsheet software. We recommend Excel, Google Sheets, or Numbers.")),
        React.createElement("div", { className: "sui-mb-8" },
            React.createElement(Accordion, { expanded: expanded, onChange: handleChange },
                React.createElement(AccordionHeader, null, "How to format the spreadsheet"),
                React.createElement("div", { className: "sui-border-solid sui-border-1 sui-border-primary sui-border-t-0" },
                    React.createElement(AccordionBody, null,
                        React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-4 sui-text-base" },
                            React.createElement(Typography, null,
                                "Create and label four columns with the following headings",
                                ' ',
                                React.createElement(Typography, { component: "span", weight: "bold" }, "First Name"),
                                ",",
                                ' ',
                                React.createElement(Typography, { component: "span", weight: "bold" }, "Last Name"),
                                ",",
                                ' ',
                                React.createElement(Typography, { component: "span", weight: "bold" }, "Email"),
                                ' ',
                                "and",
                                ' ',
                                React.createElement(Typography, { component: "span", weight: "bold" }, "Role"),
                                "."),
                            React.createElement("div", { className: "sui-grid sui-grid-cols-5 sui-gap-y-2" },
                                ['First Name', 'Last Name', 'Email', 'Role'].map(function (value, idx) { return (React.createElement("div", { key: value, className: "".concat(idx === 2 && 'sui-col-span-2') },
                                    React.createElement(Typography, { weight: "bold" }, value))); }),
                                [
                                    'Linda',
                                    'Robins',
                                    'Linda.Robins@homedepot.com',
                                    'Purchaser',
                                ].map(function (value, idx) { return (React.createElement("div", { key: value, className: "sui-py-2 sui-bg-inactive ".concat(idx === 2 && 'sui-col-span-2') },
                                    React.createElement(Typography, null, value))); })))))))));
};
